/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 12.09.2016.
 */

import {SuccessState} from '../../utils';

import {GET_METADATA} from '../../actions/metadata/actions-metadata'

const INIT_STATE = {
  metadata: {}
};

export default function (state = INIT_STATE, action) {

  switch (action.type) {

    case SuccessState(GET_METADATA):
      return {
        metadata: {
          ...state.metadata,
          [action.meta.key]: action.payload
        }
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/metadata/reducer-metadata.js